import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import { UseFormReturn } from 'react-hook-form';
import { ContactFormSchema } from './schema';

interface Props {
  form: UseFormReturn<ContactFormSchema>;
  userPresent: boolean;
  isReportingReview: boolean;
}

export const ContactFormCategoryField: React.FC<Props> = ({ form, userPresent, isReportingReview }) => {
  return (
    <FormField
      control={form.control}
      name="category"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Category</FormLabel>
          <Select onValueChange={field.onChange} value={field.value} disabled={isReportingReview}>
            <FormControl>
              <SelectTrigger className={isReportingReview ? 'bg-brand-mist' : ''}>
                <SelectValue placeholder="Select a category" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="General Inquiry">General Inquiry</SelectItem>
              <SelectItem value="Technical Support">Technical Support</SelectItem>
              <SelectItem value="Report a Problem">Report a Problem</SelectItem>
              {userPresent && <SelectItem value="Report a Review">Report a Review</SelectItem>}
              <SelectItem value="Feature Request">Feature Request</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
